import { Turbo } from '@hotwired/turbo-rails';
Turbo.session.drive = false;

import 'controllers';

import 'channels';
import colorChannel from '../channels/color_channel';
